import type { RouteType } from "../builder/mapping/page";
import { EventsDefinition, EventsDispatcher } from "../helpers/EventDispatcher";
import { ErrorPageType } from "./AnalyticsTracker";

class EventsDispatcherDOM<TEvents extends EventsDefinition<TEvents>>
  implements EventsDispatcher<TEvents>
{
  on<E extends keyof TEvents>(event: E, callback: TEvents[E]): this {
    window.addEventListener(event as string, (e: Event) => {
      const customEvent = e as CustomEvent;
      callback(...(customEvent.detail || []));
    });
    return this;
  }

  dispatch<E extends keyof TEvents>(
    event: E,
    ...args: Parameters<TEvents[E]>
  ): void {
    window.dispatchEvent(
      new CustomEvent(event as string, {
        detail: args.length > 1 ? args : args[0],
      }),
    );
  }
}

export interface Events {
  "builtfirst:page_load": (args: {
    authenticated: boolean;
    locale: string;
    pageType: RouteType | ErrorPageType;
  }) => void;
  "builtfirst:page_change": (args: {
    pageType: RouteType | ErrorPageType;
  }) => void;
  "builtfirst:page_error": (args: {
    pageType: RouteType | ErrorPageType;
  }) => void;
  "builtfirst:search": (args: { searchTerm?: string }) => void;
  "builtfirst:deal_redemption": () => void;
  "builtfirst:consent_confirm": () => void;
}

export const analyticsDispatcher = new EventsDispatcherDOM<Events>();
